// initial state
const state = () => ({})

// getters
const getters = {
    getLastBackofficeUserClicked(state) {
        if(_.isEmpty(state)) {
            const newState = JSON.parse(localStorage.getItem('@datadrive:backoffice-last-user-clicked'));
            if(newState !== null && newState !== undefined) {
                mutations.setLastBackofficeUserClicked(state, newState);
                return newState;
            } else {
                return state;
            }
        } else {
            return state;
        }
    },
}

// actions
const actions = {}

// mutations
const mutations = {
    setLastBackofficeUserClicked(state, payload) {
        if(payload && payload != undefined) {
          for (var [key, value] of Object.entries(payload)) {
              state[key] = value;
          }
          localStorage.setItem('@datadrive:backoffice-last-user-clicked', JSON.stringify(state));
        } else {
          localStorage.removeItem('@datadrive:backoffice-last-user-clicked');
        }
    }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
